import { Component, Input, OnInit } from '@angular/core';
import { FiduciaryRepository } from '@fiduciaria/Shared/Repositories/fiduciary.repository';
import { FiduciaryDocuments } from '@fiduciaria/Shared/Types/files/request-files.interface';
import { TrustRequest } from "@fiduciaria/Shared/Types/request.interface";
import { faComment, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-request-details-comments',
  templateUrl: './request-details-comments.component.html',
  styleUrls: ['./request-details-comments.component.scss']
})
export class RequestDetailsCommentsComponent implements OnInit {
  @Input() public formatDate: (date: string) => string; 
  @Input() public formatDateTime: (date: string, time: string) => string;

  @Input() public request: TrustRequest;

  public documents: FiduciaryDocuments[] = [];
  public faExclamationCircle = faExclamationCircle;
  public faComment = faComment;

  constructor(private readonly fiduciaryRepository: FiduciaryRepository) {
  }

  public ngOnInit(): void {
    this.loadDocuments();
  }

  public isCreationFile(isCreation: number): boolean {
    isCreation = (isCreation ?? 0);
    return isCreation === 1;
  }

  private groupDocumentsByLote(documents: FiduciaryDocuments[]): FiduciaryDocuments[] {
    return documents.reduce((acc, current) => {
        const x = acc.find(item => item.lote === current.lote);
        if (!x) {
            acc.push(current);
        }
        return acc;
    }, []);
  }

  public loadDocuments(): void {
    this.fiduciaryRepository.obtenerComentarios(this.request).subscribe((data: FiduciaryDocuments[]) => {
      this.documents = this.groupDocumentsByLote(data);
    });
  }
}
